import * as yup from 'yup'
import { NUMERIC_FIELD_MESSAGE, REQUIRED_FIELD_MESSAGE } from '_/utils/form-validations'

export const budgetFormSchema = yup.object().shape({
  budgetResolutions: yup.array().of(
    yup.object().shape({
      laborValue: yup.number().required(REQUIRED_FIELD_MESSAGE).typeError(NUMERIC_FIELD_MESSAGE),
      problemMedia: yup
        .array()
        .of(yup.mixed().required(REQUIRED_FIELD_MESSAGE))
        .min(1, REQUIRED_FIELD_MESSAGE)
        .required(REQUIRED_FIELD_MESSAGE),
    })
  ),
})
